import { Input } from './input.interface';


export interface Form<T> {
    name: string,
    header: string,
    type: FormType,
    sections: FormSection<T>[],
    table: FormTable | null
    uploadButton: {
        isEnabled: boolean,
        label: string
    },
    signed: boolean
}

export interface FormSection<T> {
    name: string,
    fields: FormField<T>[],
    buttons?: any[],
    tables?: FormTable[],
    width: number,
    isVisible: boolean,
    order: number
}

export interface FormField<T> {
    [key: string]: 
        ((it: FormField<T>) => T | string | null | undefined) |
        ((it: FormField<T>) => void) |
        Input<T> |
        FormFieldConditions |
        string[] | 
        string | 
        number | 
        boolean |
        any | 
        undefined;
    name: string;
    vinculatedFields: string[] | undefined;
    label: string;
    input: Input<T>;
    checkForDuplicates?: (it: string) => boolean;
    width: number,
    conditions: FormFieldConditions;
    buttons?: any[],
    order: number;    
    turnVisible?: (it: FormField<T>) => void;
    updateValue?: (it: FormField<T>) => T | string | null | undefined;
}

export interface FormTable {
    title: string,
    showIndex: boolean,
    data: string[] | string[][] | undefined, 
    style: string[] | string[][] | undefined
}

export interface FormFieldConditions {
    isRememberedOnDuplicate: boolean;
    isRequired: boolean;
    isRetained: boolean;
    hasUndoEnabled: boolean;
    isVisible: boolean;
}

export enum FormType {
    CREATION,
    EDITION,
    DUPLICATION,
    DELETION,
    INFORMATIVE,
    EXPORT,
    GENERATION
}